import { DateFormats, IconDropDownButton } from "@etframework/ui.components";
import jsPDF from "jspdf";
import { formatDate, formatDateFromNow } from "../../utils/helpers";
import {
  ActivityTimeline,
  FormatActivityLogValue,
  GetActivityLogText,
} from "./ActivityTimeline";
import { useTranslation } from "react-i18next";
import { useActivityLogs } from "../../data/queries/activityLogQueries";

export const ActivityContainer = ({ task }) => {
  const { data: activityLogs } = useActivityLogs(task?.Id);
  const { t, i18n } = useTranslation(["Overlay"], {
    useSuspense: false,
  });

  const onSelectDropDownTaskMenu = (args) => {
    args?.item?.onClick?.();
  };

  const dropdownMenu = [
    {
      id: "moreactions-print",
      text: t("Print"),
      iconCss: "fa-regular fa-print",
      onClick: () => {
        const doc = new jsPDF();
        const margin = 20,
          maxWidth = 170,
          lineHeight = 10,
          userInfoSpacing = 5;
        let yOffset = 15;

        const addPageIfNeeded = (height) => {
          if (yOffset + height > doc.internal.pageSize.height) {
            doc.addPage();
            yOffset = 20;
          }
        };

        doc.setFillColor(240, 240, 240); // Light gray background color for the container
        doc.rect(margin - 5, yOffset - 5, maxWidth + 5 * 2, 30, "F"); // Adjust height as needed

        doc.setFontSize(10).text(`${t("Activity")}`, margin, yOffset);
        yOffset += 10;
        doc
          .setFontSize(10)
          .text(`${t("Task")}: ${task?.Name}`, margin, yOffset);
        yOffset += 5;
        doc
          .setFontSize(10)
          .text(`${t("Client")}: ${task?.Client?.FullName}`, margin, yOffset);
        yOffset += 5;
        doc
          .setFontSize(10)
          .text(
            `${t("DueDate")}: ${formatDateFromNow(
              task?.DueDate,
              i18n.language,
              DateFormats.ShortDateTimeFormat.momentJsFormat
            )}`,
            margin,
            yOffset
          );
        yOffset += 20;

        activityLogs.forEach((activity) => {
          const actionText = GetActivityLogText(
            t,
            activity?.Action,
            activity?.FieldModified,
            activity?.IsSystemLog,
            activity?.UserFullName
          );
          const originalValue = FormatActivityLogValue(
            activity?.FieldModified,
            activity?.OriginalValue,
            t
          );
          const newValue = FormatActivityLogValue(
            activity?.FieldModified,
            activity?.NewValue,
            t
          );

          doc.setTextColor(0, 0, 0);
          doc.splitTextToSize(actionText, maxWidth).forEach((line) => {
            addPageIfNeeded(lineHeight);
            doc.text(line, margin, yOffset);
            yOffset += 5;
          });

          const addActionText = (text) => {
            if (text) {
              addPageIfNeeded(lineHeight);
              doc.text(text, margin, yOffset);
              yOffset += lineHeight;
            }
          };

          if (activity?.NewValue && activity?.OriginalValue) {
            const action = `${originalValue} ${t("To")} ${newValue}`;
            const actionLines = doc.splitTextToSize(action, maxWidth);
            actionLines.forEach((line) => {
              addPageIfNeeded(lineHeight);
              doc.text(line, margin, yOffset);
              yOffset += 5;
            });
          } else {
            if (newValue) addActionText(newValue);
            else addActionText(originalValue);
          }
          yOffset += 5;

          doc.setTextColor(117, 117, 117);
          const createdDate = `${formatDate(
            activity?.CreatedDate,
            DateFormats.ShortDateTimeFormat.momentJsFormat
          )}`;

          addPageIfNeeded(userInfoSpacing);
          doc.text(createdDate, margin, yOffset);
          yOffset += 10;
          doc.setDrawColor(179, 179, 179);
          doc.line(margin, yOffset, margin + maxWidth, yOffset);

          addPageIfNeeded(10);
          yOffset += 10;
        });

        doc.save("activity.pdf");
      },
    },
  ];

  return (
    <div className="activity-container tab-item">
      <div className="d-flex justify-content-start align-items-center gap-1 p-3 bb-1-light-gray bg-et-lightest-gray">
        <div className="fs-14">{t("Activity")}</div>
        <IconDropDownButton
          id={"moreactions-dropdown"}
          iconCss="fa-regular fa-ellipsis-vertical"
          className="more-actions-dropdown"
          select={onSelectDropDownTaskMenu}
          items={dropdownMenu}
        />
      </div>
      <ActivityTimeline activityLogs={activityLogs} />
    </div>
  );
};
